import React from 'react';
import Loading from '../Loading';

function DownloadLoadingPopup({ open, message = 'Baixando documento...' }) {
  if (!open) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 2000,
        backgroundColor: 'rgba(35, 45, 100, 0.28)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          minWidth: 280,
          maxWidth: 420,
          background: '#FFFFFF',
          border: '1px solid #D7DCE5',
          borderRadius: 8,
          padding: '18px 22px',
          boxShadow: '0 12px 30px rgba(0, 0, 0, 0.18)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 10,
        }}
      >
        <Loading />
        <span
          style={{
            color: '#232D64',
            fontSize: '14px',
            fontWeight: 600,
            textAlign: 'center',
            fontFamily: 'inherit',
          }}
        >
          {message}
        </span>
      </div>
    </div>
  );
}

export default DownloadLoadingPopup;
